module.exports = __webpack_public_path__ + "static/media/bg-bar.5717ed96.jpg";